import React from 'react';

export const Dropdown = ({
  name,
  value,
  onChange,
  onBlur,
  options,
  placeholder = "Select an option",
  required = false,
  error,
  icon,
  className = "",
  disabled = false,
  showDefaultOption = true
}) => {
  return (
    <div className="space-y-2">
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {icon}
          </div>
        )}
        <select
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          className={`
            block w-full py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 
            bg-white text-gray-900 placeholder-gray-500 ${icon ? 'pl-10' : 'pl-3'} pr-3 ${className}
            ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}
            ${error ? 'border-error-500 focus:ring-error-500 focus:border-error-500' : ''}
          `}
          required={required}
        >
          {showDefaultOption && <option key="default" value="">{placeholder}</option>}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {error && (
        <p className="text-error-600 text-sm">{error}</p>
      )}
    </div>
  );
};
